module.exports = __webpack_public_path__ + "img/house-1.9e424e43.jpg";